export const EXTERNAL_PATH_CLUEY_LEARNING = 'https://clueylearning';
export const EXTERNAL_PATH_COUNTRY_AU = '.com.au/';
export const EXTERNAL_PATH_COUNTRY_NZ = '.co.nz/';

export const EXTERNAL_PATH_SERVICE_FEES = `service-fees`;
export const EXTERNAL_PATH_REFUND_POLICY = `refund-policy`;

